<template>
  <div id="part-side-bar">
    <menuItem
      v-for="(item,i) in menus"
      :key="i"
      :item="item"
      :level="0"
      :activeMenu="activeMenu"
      :indexMenun="i"
      :allLength="menus.length"
    />
  </div>
</template>

<script>
import menuItem from "./item";

export default {
  components: { menuItem },
  props: ["menus", "activeMenu"],
};
</script>

<style lang="scss">
@import "../style/var";

#part-side-bar {
  flex: 1;
  overflow: auto;
  overflow: overlay;
}
</style>
